import { useState, useEffect } from "react";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import UserMenu from "../components/UserMenu";
import { useSelector } from "react-redux";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import REPORT_BASE_URL from "../utilities/ReportConfig";

const Other = () => {
  const [currentDate, setCurrentDate] = useState("");
  const [cashReceiptData, setCashReceiptData] = useState("");
  const [fromYear, setFromYear] = useState("");
  const [toYear, setToYear] = useState("");
  const [selectedYears, setSelectedYears] = useState(0);

  const [updateCashReceiptDetails, setUpdateCashReceiptData] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false); // For API loading state
  const [saveLoading, setSaveLoading] = useState(false); // For save button loading state
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    prtname: "",
    prt2name: "",
    fee: "",
    property_detail: "",
  });
  const [validationErrors, setValidationErrors] = useState({
    prtname: false,
    prt2name: false,
    fee: false,
  });
  const location = useLocation();
  const { regYear, vol, sr, typeRecpt, mod } = location.state || {};
  console.log("updateCashReceiptDetails", updateCashReceiptDetails);
  console.log("cashReceiptData", cashReceiptData);
  const navigate = useNavigate();
  const { userDetails } = useSelector((state) => state.auth);

  useEffect(() => {
    const today = new Date();
    const formattedDate = `${today.getDate()}/${
      today.getMonth() + 1
    }/${today.getFullYear()}`;
    setCurrentDate(formattedDate);
  }, []);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
    // Clear validation error when the user starts typing
    setValidationErrors((prev) => ({
      ...prev,
      [id]: false,
    }));
  };

  const fetchCashReceiptDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/CashReceipt/get_details_Virtual_Load_Cashreceipt_Sp/${userDetails.dcode}/${userDetails.srocode}/0/receipt_MISS`
      );

      if (response.data.statusResponse.statusCode === 200) {
        setCashReceiptData(response.data.cashReceiptDetails);
        setEditMode(false);
      } else {
        setError("No data found");
      }
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  const fetchUpdateCashReceiptDetails = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/CashReceipt/GetReceiptModification/${userDetails.dcode}/${userDetails.srocode}/${vol}/${sr}/${regYear}`
      );

      setUpdateCashReceiptData(response.data[0]);
      setEditMode(true);
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    debugger;
    if (typeRecpt === "Others" && mod === true) {
      fetchUpdateCashReceiptDetails();
    } else {
      fetchCashReceiptDetails();
    }
  }, [typeRecpt, mod]); // Dependency array ensures this runs when typeRecpt changes
  useEffect(() => {
    if (editMode && updateCashReceiptDetails) {
      setFormData({
        prtname: updateCashReceiptDetails.appName || "",
        prt2name: updateCashReceiptDetails.deedType || "",
        property_detail: updateCashReceiptDetails.regNo || "",
        code: updateCashReceiptDetails.appliNo || "",
        tyear: updateCashReceiptDetails.defYear || "",
        fyear: updateCashReceiptDetails.regNo || "",
        fee: updateCashReceiptDetails.miscFee || "",
        token: updateCashReceiptDetails.page || "",
      });

      // setFee(updateCashReceiptDetails.miscFee || '');
    }
  }, [updateCashReceiptDetails, editMode]);

  const CashReceiptReportLink = (printData) => {
    debugger;
    return `${REPORT_BASE_URL}/Report/CashReceiptReports.aspx?dcode=${
      userDetails.dcode
    }&srocode=${userDetails.srocode}&vol=${printData.vol}&sr=${
      printData.sr
    }&year=${
      printData.regYear
    }&recptDate=${currentDate}&tdate=${currentDate}&mode=receipt&mode1=${"Others"}`;
  };

  const handleSave = async () => {
    // Check if required fields are filled
    const errors = {
      prtname: !formData.prtname,
      prt2name: !formData.prt2name,
      fee: !formData.fee,
    };

    setValidationErrors(errors);

    // If any field is empty, show error and return
    if (errors.prtname || errors.prt2name || errors.fee) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      setSaveLoading(true); // Start loader
      const formData2 = new FormData();

      const payload = {
        dcode: userDetails.dcode,
        srocode: userDetails.srocode,
        pimode: "receipt_MISS",
        tokenno: 0,
        misc_fee: formData.fee,
        code: selectedYears,
        fyear: fromYear || 0,
        tyear: toYear || 0,
        nakalown: "string",
        nakalregdate: "",
        nakalcopy: "",
        mode: "string",
        prtname: formData.prtname,
        prt2name: formData.prt2name,
        property_detail: formData.property_detail,
      };

      Object.keys(payload).forEach((key) => {
        formData2.append(key, payload[key]);
      });

      const response = await axios.post(
        `${API_BASE_URL}/CashReceipt/Insert_Cashreceipt_Sp`,
        formData2,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data) {
        console.log("API Response:", response.data);
        const printData = response.data.response;
        fetchCashReceiptDetails();
        toast.success("Fees Submitted Successfully");
        const reportUrl = CashReceiptReportLink(
          printData,
          new Date().toISOString().split("T")[0] // Format as YYYY-MM-DD
        );

        // Open report in a new tab
        window.open(reportUrl, "_blank");
        setFormData({
          prtname: "",
          prt2name: "",
          fee: "",
          property_detail: "",
        });
      } else {
        throw new Error("Not found");
      }
    } catch (err) {
      console.error("Error in Insert Search Receipt API:", err);
      toast.error("Error occurred while saving the receipt");
    } finally {
      setSaveLoading(false); // Stop loader
    }
  };

  const handleUpdate = async () => {
    const errors = {
      prtname: !formData.prtname,
      prt2name: !formData.prt2name,
      fee: !formData.fee,
    };

    setValidationErrors(errors);

    // If any field is empty, show error and return
    if (errors.prtname || errors.prt2name || errors.fee) {
      toast.error("Please fill all required fields");
      return;
    }
    try {
      const formData2 = new FormData();
      const payload = {
        dcode: userDetails.dcode,
        srocode: userDetails.srocode,
        pimode: "receipt_MISS",
        tokenno: 0,
        misc_fee: formData.fee,
        code: selectedYears,
        fyear: fromYear || 0,
        tyear: toYear || 0,
        nakalown: "string",
        nakalregdate: "",
        nakalcopy: "",
        mode: "string",
        prtname: formData.prtname,
        prt2name: formData.prt2name,
        property_detail: formData.property_detail,
        vol: updateCashReceiptDetails?.vol || "",
        sr: updateCashReceiptDetails?.sr || "",
        epayment_rfee: updateCashReceiptDetails?.epayment_rfee || "",
      };

      Object.keys(payload).forEach((key) => {
        formData2.append(key, payload[key]);
      });

      const response = await axios.post(
        `${API_BASE_URL}/CashReceipt/Update_Cashreceipt_Sp`,
        formData2,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data) {
        console.log("API Response:", response.data);
        const printData = response.data.response;
        fetchCashReceiptDetails();
        toast.success("Fees Submitted Successfully");

        // Generate the report URL
        const reportUrl = CashReceiptReportLink(
          printData,
          new Date().toISOString().split("T")[0] // Format as YYYY-MM-DD
        );

        // Open report in a new tab
        window.open(reportUrl, "_blank");
        navigate("/ModifyReciept");
      } else {
        throw new Error("Not found");
      }
    } catch (err) {
      console.error("Error in Update Search Receipt API:", err);
      alert("Error occurred while updating the receipt.");
    }
  };

  return (
    <div className="flex flex-col md:flex-row h-screen">
      <SideMenu className="w-full md:w-64" />
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="shadow-sm">
          <Header />
        </div>

        <div className="flex flex-1 flex-col md:flex-row overflow-y-auto">
          {/* Left Side */}
          <div className="flex-1 p-2 md:p-4">
            <div className="p-4 md:p-8 bg-gray-100 min-h-screen">
              <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-4">
                New Receipt - Other
              </h1>

              <div className="bg-white p-4 md:p-6 space-y-4">
                {/* Date and Details Section */}
                <div className="flex flex-col space-y-4 md:space-y-0 md:flex-row md:items-center md:space-x-6">
                  <div>
                    <b>Date: </b>{" "}
                    <span>
                      {editMode
                        ? updateCashReceiptDetails.recptDate
                        : currentDate}
                    </span>
                  </div>
                  <div>
                    <b>Vol no: </b>{" "}
                    <span>
                      {editMode
                        ? updateCashReceiptDetails.vol
                        : cashReceiptData.vol}
                    </span>
                  </div>
                  <div>
                    <b>Serial no: </b>{" "}
                    <span>
                      {editMode
                        ? updateCashReceiptDetails.sr
                        : cashReceiptData.sr}
                    </span>
                  </div>
                </div>

                {/* Text Inputs */}
                <div className="grid grid-cols-4 md:grid-cols-4 gap-4 mt-4">
                  <div className="col-span-2">
                    <div className="relative">
                      <input
                        id="prtname"
                        type="text"
                        value={formData.prtname}
                        onChange={handleChange}
                        className={`w-full border ${
                          validationErrors.prtname
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                        placeholder=""
                      />
                      <label
                        htmlFor="prtname"
                        className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                      >
                        Applicant Name
                      </label>
                    </div>
                  </div>

                  <div className="col-span-2">
                    <div className="relative">
                      <input
                        id="prt2name"
                        type="text"
                        value={formData.prt2name}
                        onChange={handleChange}
                        className={`w-full border ${
                          validationErrors.prt2name
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                        placeholder=""
                      />
                      <label
                        htmlFor="prt2name"
                        className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                      >
                        Applicant Type
                      </label>
                    </div>
                  </div>

                  <div className="col-span-2">
                    <div className="relative">
                      <input
                        id="fee"
                        type="number"
                        value={formData.fee}
                        onChange={handleChange}
                        placeholder=""
                        className={`w-full border ${
                          validationErrors.fee
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                      />
                      <label
                        htmlFor="fee"
                        className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                      >
                        Fee
                      </label>
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="col-span-2 col-start-1 md:col-span-1 md:col-end-3">
                    <div className="relative">
                      <button
                        onClick={editMode ? handleUpdate : handleSave}
                        disabled={saveLoading} // Disable button when loading
                        className="w-full bg-blue-400 text-white px-6 py-2 rounded hover:bg-blue-700 focus:outline-none flex items-center justify-center"
                      >
                        {
                          saveLoading ? (
                            <div className="flex items-center">
                              <svg
                                className="animate-spin h-5 w-5 mr-3 text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                ></circle>
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                              </svg>
                              Saving...
                            </div>
                          ) : editMode ? (
                            "UPDATE"
                          ) : (
                            "SAVE"
                          ) // ✅ Fixed
                        }
                      </button>
                    </div>
                  </div>
                  <div className="col-span-2 md:col-span-1 md:col-end-4">
                    <div className="relative">
                      <button className="w-full text-[#DA0000] px-6 py-2 border border-[#DA0000] rounded hover:bg-red-100 focus:outline-none">
                        CANCEL
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Hidden on mobile, visible on medium screens and above */}
          <div className="hidden md:block w-64 h-full">
            <UserMenu />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Other;
